import request from "@/utils/request";

/**
 * L'accueil par widgets.
 *
 * Quatre appels, tous réservés au périmètre interne côté serveur : un client
 * extranet reçoit 403. Le front ne rejoue pas ce calcul — il s'abstient quand
 * il sait déjà que l'utilisateur est extranet, et se replie sur les raccourcis
 * seuls si le serveur refuse.
 */

/**
 * Le catalogue des widgets que cette personne peut voir, sans leurs données.
 *
 * Volontairement sans permission par widget : le serveur a déjà filtré, et
 * refaire le calcul ici masquerait ce qu'il autorise — « Mes tâches » s'ouvre
 * sur les projets OU sur les processus, un seul nom de droit en dirait faux.
 */
export function catalogueWidgets() {
    return request.get("/api/dashboard/widgets");
}

/**
 * Les données d'un widget. Un appel par clé, pour qu'un widget lent ou en
 * panne ne retienne pas l'accueil entier.
 *
 * Répond 404 aussi bien pour une clé inconnue que pour une clé refusée.
 */
export function donneesWidget(cle) {
    return request.get(`/api/dashboard/widgets/${cle}`);
}

/**
 * La disposition de cette personne, ou le repli de son profil.
 *
 * `source` vaut `defaut` tant que rien n'a été réglé — et dans ce cas rien
 * n'est écrit en base, le repli est recalculé à chaque visite pour suivre les
 * droits. `retires` compte les widgets perdus faute de droit, `nouveaux` liste
 * les clés autorisées absentes de la disposition.
 */
export function chargerDisposition() {
    return request.get("/api/dashboard/layout");
}

/**
 * Enregistre la disposition réglée par l'utilisateur.
 *
 * `source` n'accepte que `utilisateur` aujourd'hui : `luce` est refusé côté
 * serveur tant que la proposition automatique n'existe pas.
 */
export function enregistrerDisposition(layout) {
    return request.put("/api/dashboard/layout", { layout, source: "utilisateur" });
}

/**
 * Oublie la disposition réglée et rend le repli du profil.
 *
 * Le serveur supprime la ligne plutôt que d'y écrire le repli : celui-ci se
 * recalcule à chaque lecture et suit donc les droits et les tailles du moment.
 */
export function reinitialiserDisposition() {
    return request.delete("/api/dashboard/layout");
}
